<!-- Select Button Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    @if (options && options.length > 0) {
      <p-selectButton id="{{ name }}"
        class="whitespace-nowrap"
        ariaLabelledBy="{{ name }}_label"
        formControlName="{{ name }}"
        [disableControl]="disabled"
        [options]="options"
        optionLabel="{{ optionLabel }}"
        optionValue="{{ optionValue }}"
        [allowEmpty]="allowEmpty"
        [ngClass]="{
          'ng-invalid': control.invalid && control.touched,
          'ng-dirty': control.invalid && control.touched
        }"
        (onChange)="valueChange.emit($event)">
        <ng-template let-item pTemplate>
          <div class="flex flex-row align-content-baseline justify-content-center column-gap-2">
            @if (optionIcons[item.value]; as iconClass) {
              <div class="flex">
                <i class="{{ iconClass }} align-self-center"></i>
              </div>
            }
            @if (showOptionLabel) {
              <div class="flex">
                {{ item.name | translate }}
              </div>
            }
          </div>
        </ng-template>
      </p-selectButton>
    }
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}